var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isMircoApp
    ? _c(
        "div",
        { staticClass: "app-wrapper", class: _vm.classObj },
        [
          _vm.showSettings ? _c("right-panel", [_c("settings")], 1) : _vm._e(),
          _vm._v(" "),
          _c(
            "el-container",
            { staticClass: "wrap-content" },
            [
              _c(
                "el-header",
                [
                  _c("navbar", {
                    style:
                      "background:rgba(" +
                      _vm.colorConversionRgb(_vm.navBarBg) +
                      ")",
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-container",
                { staticClass: "inner-conternt" },
                [
                  _c(
                    "el-aside",
                    [
                      _c("head-menu", {
                        staticClass: "fl",
                        attrs: { id: "navbar-head-menu-container" },
                      }),
                      _vm._v(" "),
                      _c("sidebar", {
                        staticClass: "sidebar-container",
                        style:
                          "background:rgba(" +
                          _vm.colorConversionRgb(_vm.leftNavBg) +
                          ")",
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-main",
                    {
                      style:
                        "background:rgba(" +
                        _vm.colorConversionRgb(_vm.bg) +
                        ")",
                    },
                    [
                      _vm.needTagsView ? _c("tags-view") : _vm._e(),
                      _vm._v(" "),
                      _c("app-main"),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _c("div", { staticClass: "mirco-layout" }, [_c("app-main")], 1)
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }